import PropTypes from 'prop-types'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/elements/select'

const CustomSelect = ({ onChange, options = [], placeholder = '', value = null, ...rest }) => (
  <Select onValueChange={onChange} value={value}>
    <SelectTrigger className="w-full" {...rest}>
      <SelectValue placeholder={placeholder} />
    </SelectTrigger>
    <SelectContent className="max-h-60 w-full overflow-auto">
      {options.map((o) => (
        <SelectItem key={o.id} value={o.id}>
          {o.label}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
)

CustomSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  value: PropTypes.string,
}

export default CustomSelect
